export const shortcutIconVersionUtils = () => {
  const { 2: version = null } =
    new RegExp(
      /( AutoAtendimento| SelfOrdering| pdv_cloud)\/(.*) Chrome/g
    ).exec(window.navigator.userAgent) || [];

  return version;
};
